/* global Modernizr */

var App = App || {};

App.PrimaryNav = (function ($) {
    "use strict";

    var $nav,
        $header,
        onTimer = {},
        offTimer = {},
        focusList = [],
        focusIndex = 0,
        currentMenu;

    function init() {
        $nav = $('#primary-nav');
        $header = $('#site-header');

        $nav.find('.primary-nav__level-1-item--has-children > a, .primary-nav__level-1-item > .primary-nav__menu').on('mouseenter focusin', function () {
            var $this = $(this).parents('li'),
                key = $this.find('> a').attr('id');

            clearTimeout(offTimer[key]);

            if (!$this.hasClass('primary-nav__level-1-item--open')) {
                onTimer[key] = setTimeout(function () { openMenu($this); }, 100);
            }
        });

        $nav.find('.primary-nav__level-1-item--has-children').on('mouseleave focusout', function () {
            var $this = $(this),
                key = $this.find('> a').attr('id');

            clearTimeout(onTimer[key]);

            if ($this.hasClass('primary-nav__level-1-item--open')) {
                offTimer[key] = setTimeout(function () { closeMenu($this); }, 450);
            }
        });
    }

    function setCurrentMenu($menu) {
        currentMenu = $menu;
    }

    function getCurrentMenu() {
        return currentMenu;
    }

    function openMenu($item) {
        var $menu = $item.find('.primary-nav__menu');

        focusList = [];
        focusIndex = 0;

        $.each($menu.find('a'), function () {
            focusList.push(this);
        });

        if (getCurrentMenu()) {
            closeMenu(getCurrentMenu());
        }

        $item.addClass('primary-nav__level-1-item--open');
        $menu.show();
        setCurrentMenu($item);
    }

    function closeMenu($item) {
        var $menu = $item.find('.primary-nav__menu');

        $item.removeClass('primary-nav__level-1-item--open');
        $menu.hide();
        setCurrentMenu(null);
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.PrimaryNav.init();
});